import { AttemptErrorCodes } from '../../../../typings/EventAttempt.interface';

export const getErrorCodeLabels = (): Record<AttemptErrorCodes, string> => ({
  // Request was not attempted
  CANCELLED:
    'The delivery has been cancelled either manually, by archiving or deleting the associated connection.',
  DATA_ARCHIVED: 'The event data has been archived.',
  BULK_RETRY_CANCELLED: 'Bulk retry that triggered this attempt was cancelled.',
  CANCELLED_PAST_RETENTION:
    'The delivery has been cancelled because it was past the retention period of your project.',
  DESTINATION_AUTH_FAILED:
    "Hookdeck couldn't apply the destination's authentication method to this event, so no delivery attempt was made. Check the destination's authentication settings. With Standard Webhooks, the webhook-id must not contain a period.",
  // Request was attempted
  CLI: 'The attempt failed to be forwarded to your local server by the CLI. Check your console for more details.',
  CLI_UNAVAILABLE: 'The request to your CLI could not be made because the CLI was not connected.',
  CLI_BINARY_UNSUPPORTED:
    'Binary payload delivery is not supported by the CLI. Use an HTTP destination for this event.',
  CONNECTION_REFUSED:
    'The request to your destination could not be made because the connection was refused.',
  CONNECTION_RESET:
    'The request to your destination could not be made because the connection was forcibly closed by your server.',
  CONNECTION_TIMEOUT:
    'The request to your destination could not be made because the connection could not be established in time. Your server may be down or not accepting connections.',
  DNS_LOOKUP_FAILED: 'The DNS lookup for your destination domain failed or timed out.',
  DNS_NO_RECORDS:
    'Your destination domain does not resolve to a public IPv4 address. Hookdeck can only deliver to domains with an A record pointing to a public IP.',
  BAD_RESPONSE: 'Your destination server response was malformed or invalid.',
  NETWORK_REQUEST_CANCELED:
    'The request to your destination was cancelled before it could complete.',
  TOO_MANY_REDIRECTS:
    'Too many redirects were encountered while sending the request to your destination.',
  INVALID_CHARACTER:
    'Invalid characters were found in the request headers or URL. Work with source provider to fix or create a transformation to remove the offending characters.',
  INVALID_URL: 'The destination URL format is invalid or malformed.',
  NETWORK_ERROR: 'A network error occurred while attempting to reach your destination.',
  ERR_SSL_WRONG_VERSION_NUMBER:
    'Indicates a mismatch between the SSL/TLS version expected by your destination and the version supported by the server.',
  ERR_TLS_CERT_ALTNAME_INVALID: "Your destination's SSL certificate is not valid.",
  HOST_UNREACHABLE: 'Your destination host is unreachable.',
  INTERNAL_ERROR:
    'An internal delivery error occurred. This is not an issue with your destination.',
  MISSING_URL:
    'Your destination does not have a HTTP URL configured. It can only receive attempts on the CLI.',
  NETWORK_UNREACHABLE: "Your destination's network is unreachable.",
  NOT_FOUND:
    'The request to your destination could not be made because the domain or host was not found or unavailable.',
  OAUTH2_HANDSHAKE_FAILED:
    'The OAuth2 handshaking process failed. This usually indicates wrong configuration or an error with the Oauth2 server.',
  PAYLOAD_TOO_LARGE:
    'The request body exceeds the maximum size that can be delivered to your destination.',
  PROTOCOL_ERROR:
    'A protocol error occurred during our attempt to deliver the request. This usually indicates a network error.',
  SELF_SIGNED_CERT:
    'Your destination uses a self-signed SSL certificate. Hookdeck only supports valid, verifiable certificates.',
  SOCKET_CLOSED: 'The destination socket was closed during the request transmission.',
  SSL_CERT_EXPIRED: "Your destination's SSL certificate is expired.",
  SSL_ERROR_CA_UNKNOWN:
    'The CA for the certificate of the server in your destination is unknown. This is generally a server configuration error, and needs to be resolved at the destination server.',
  TIMEOUT:
    'The request exceeded the timeout configured for your destination. The request might have still been processed on your destination.',
  UNABLE_TO_GET_ISSUER_CERT: 'Unable to retrieve the SSL certificate issuer information.',
  Z_DATA_ERROR:
    'Your destination returned compressed data (like gzip, deflate or brotli) but the data stream is invalid or lacks the expected headers.',
  UNKNOWN:
    'An unknown error occured while sending a request to your destination. The team has been notified and is investigating.',
});
